<template>
  <div class="serviceModel">
    <div class="title">{{serviceName}}</div>
    <ul class="servicelist">
      <li v-for="(item, index) in serviceList" :key="index" @click="onItem(item)">
        <img v-if="item.accessByVpn === '是'" class="vpn" src="../../assets/images/shang/vpnTwo.png" alt="">
        <div class="img-container">
          <div>
            <img :src="item.icon" alt="">
          </div>
        </div>
        <div class="info-container">
          <h3>{{item.name}}</h3>
          <div class="star-container">
            <rating :score="item.score?item.score:3.5"></rating>
          </div>
          <p>{{item.collectionNum}}人收藏</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import rating from "components/globalComp/rating"

  export default {
    name: "serviceModel",
    props: {
      serviceList: null,
      serviceName: ''
    },
    components: {
      rating
    },
    methods: {
      onItem (e) {
        this.$emit('onItem', e)
      }
    }
  }
</script>

<style scoped lang="stylus">
  @import "~common/stylus/config.styl"
  .serviceModel
    width 100%
    height 100%
    position relative

    .title
      width 100%
      height 50px
      line-height 50px
      color #333333
      font-size 16px
      padding-left 15px
      font-weight bold
      position absolute
      top 0
      left 0
      background #ffffff
      z-index 99

    .servicelist
      height 100%
      overflow-y scroll
      padding-top 50px
      padding-bottom 10px

      &::-webkit-scrollbar
        display none

      &::after
        content ""
        display block
        width 100%
        clear both

      & > li
        width 261px
        height 120px
        float left
        cursor pointer
        transition 300ms
        border-radius 8px
        border 1px solid rgba(240, 240, 240, 1)
        box-shadow 0px 2px 20px 0px rgba(28, 96, 130, 0.15)
        background #ffffff
        margin 10px 0 0 10px
        position relative
        .vpn
          width 50px
          height 50px
          position absolute
          top -0.1rem
          right -0.1rem

        .img-container
          display table
          width 87px
          height 100%
          float left
          text-align center
          position relative

          div
            display table-cell
            vertical-align middle

            img
              width 70px
              height auto
              max-height 100px
              border-radius 50%
              float right

            span
              position absolute
              display block
              border-radius 50%
              top 20px
              right 6px

              i
                font-size 20px
                color #77d878
                background-color #ffffff
                border-radius 50%

        .info-container
          width 162px
          float right

          h3, p
            white-space nowrap
            overflow hidden
            text-overflow ellipsis

          h3
            font-weight bolder
            padding-right 10px
            font-size 16px
            color #222222
            margin-top 25px
            margin-bottom 12px

          p
            font-size 14px
            color #999999
            letter-spacing 0
            margin-top 12px

          .star-container
            margin-top 5px
            margin-left -1px
            width 80px
            height 16px

</style>


// WEBPACK FOOTER //
// src/components/personal/serviceModel.vue